import React from "react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import {
  useCreateAssignmentMutation,
  useGetAssignmentsQuery,
} from "../../../features/assignments/assignmentsApi";
import { useGetVideosQuery } from "../../../features/videos/videosApi";
import Assignment from "./Assignment";

const MySwal = withReactContent(Swal);

const Assignments = () => {
  const { data: assignments, isError, isLoading } = useGetAssignmentsQuery();
  const {
    data: videos,
    isError: videoError,
    isLoading: videoLoading,
  } = useGetVideosQuery();



  const [addAssignment] = useCreateAssignmentMutation();

  const handleAddAssignment = async () => {
    await MySwal.fire({
      // title: title,
      width: 800,
      showCancelButton: true,
      confirmButtonText: "Add Assignment",
      showLoaderOnConfirm: true,
      background: "#080E1B",
      html: `
      <div class="flex flex-col gap-y-2">
        <label for="title" class="text-white text-left mb-3 font-semibold">Title</label>
        <input required id="title" placeholder="Enter assigment title" class="input input-bordered input-primary w-full text-white" value="" />
        <label for="select_video" class="text-white text-left my-3 font-semibold">Select a video</label>
        <select id="select_video" class="select disabled:text-[#9CA3AF] select-primary w-full text-white">
            <option disabled selected class="text-[#9CA3AF] bg-[#080E1B]">Select a video to add assignment to</option>
            ${videos
              .map((video) => {
                return `<option data-id="${video.id}" class="text-white bg-[#080E1B]">${video.title}</option>`;
              })
              .join("")}
        </select>
        <label for="totalMark" class="text-white text-left my-3 font-semibold">Total Mark</label>
        <input type="number" class="input input-bordered input-primary w-full text-white" max={100} min={0} id="totalMark" />
      </div>
      `,
      focusConfirm: false,
      preConfirm: () => {
        return {
          title: document.getElementById("title").value,
          video_id: Number(
            document.getElementById("select_video").selectedOptions[0].dataset
              .id
          ),
          video_title: document.getElementById("select_video").value,
          totalMark: Number(document.getElementById("totalMark").value),
        };
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const { title, video_id, video_title, totalMark } = result.value;
        if (!title || !video_id || !video_title || !totalMark) {
          MySwal.fire({
            icon: "error",
            title: "<span class='text-white'>Oops...</span>",
            background: "#080E1B",
            text: "Please fill all the fields",
          });
          return;
        }
        addAssignment({
          title: title,
          video_id: video_id,
          video_title: video_title,
          totalMark: totalMark,
        });
      }
    });

  };

  // decide what to show based on the state
  let content = null;
  if (isLoading) {
    content = <div>Loading...</div>;
  }
  if (!isLoading && isError) {
    content = <div>Something went wrong...</div>;
  }
  if (!isLoading && !isError && assignments.length > 0) {
    content = assignments.map((assignment) => (
      <Assignment videos={videos} key={assignment.id} assignment={assignment} />
    ));
  }

  return (
    <div className="mx-auto max-w-full px-5 lg:px-20">
      <div className="px-3 py-20 bg-opacity-10">
        <div className="w-full flex">
          <button onClick={handleAddAssignment} className="btn ml-auto">
            Add Assignment
          </button>
        </div>
        <div className="overflow-x-auto mt-4">
          <table className="divide-y-1 text-base divide-gray-600 w-full">
            <thead>
              <tr>
                <th className="table-th">Title</th>
                <th className="table-th">Video Title</th>
                <th className="table-th">Mark</th>
                <th className="table-th">Action</th>
              </tr>
            </thead>

            <tbody className="divide-y divide-slate-600/50">{content}</tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Assignments;
